const tacSelector = rdxState =>
  rdxState && rdxState.tacReducer && rdxState.tacReducer.visible;

export default tacSelector;
